module.exports = __webpack_public_path__ + "img/unilorin-icon.61bab747.png";